import React from 'react';

export default function AboutSection() {
  return (
    <section id="about-us" className="py-24 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-blue-500 via-teal-500 to-purple-500"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-100 text-blue-600 text-sm font-semibold uppercase tracking-wider rounded-full mb-4">
            About Us
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            About STEMForge Tech Labs
          </h2>
        </div>

        {/* About Content */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-3xl p-10 border border-blue-100">
            <p className="text-sm text-gray-700 leading-relaxed mb-6">
              STEMForge Tech Labs is an education technology research and development company focused on building scalable, future-ready STEM learning ecosystems for schools and institutions. We integrate Artificial Intelligence, Robotics, IoT, Data Science, and emerging technologies into structured academic frameworks aligned with national education standards.
            </p>
            <p className="text-sm text-gray-700 leading-relaxed">
              Our model combines curriculum design, laboratory infrastructure, educator enablement, and outcome-based assessment to deliver measurable skill development. Expanding institutional partnerships, STEMForge Tech Labs is positioned to drive long-term impact in the K–12 and higher education skill development ecosystem.
            </p>
          </div>

          {/* Impact Stats */}
          <div className="grid grid-cols-3 gap-6 mt-12">
            <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-2xl p-6 text-center border border-purple-100 hover:shadow-lg transition-all duration-300">
              <div className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-purple-600 to-blue-500 bg-clip-text text-transparent mb-2">
                AI
              </div>
              <div className="text-gray-600 font-medium">Integrated Learning</div>
            </div>
            <div className="bg-gradient-to-br from-teal-50 to-green-50 rounded-2xl p-6 text-center border border-teal-100 hover:shadow-lg transition-all duration-300">
              <div className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-teal-600 to-green-500 bg-clip-text text-transparent mb-2">
                IoT
              </div>
              <div className="text-gray-600 font-medium">Smart Solutions</div>
            </div>
            <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-6 text-center border border-orange-100 hover:shadow-lg transition-all duration-300">
              <div className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-orange-600 to-red-500 bg-clip-text text-transparent mb-2">
                K-12
              </div>
              <div className="text-gray-600 font-medium">Education Focus</div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <p className="text-base text-gray-600 mb-6">
            Ready to transform your institution with future-ready STEM education?
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-teal-500 text-white text-sm font-semibold rounded-full hover:shadow-lg transition-all duration-300"
            >
              <i className="ri-calendar-line text-base"></i>
              Schedule a Consultation
            </a>
            <a
              href="/solutions"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-gray-700 text-sm font-semibold rounded-full border-2 border-gray-200 hover:border-blue-500 hover:text-blue-600 transition-all duration-300"
            >
              Explore Our Solutions
              <i className="ri-arrow-right-line text-base"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
